module.exports = __webpack_public_path__ + "static/img/redeem_card_bg.ecfa89d0.png";